var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVideoCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-video-call-1353298 1",
    clipPath: "url(#clip0_3252_16677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.625 5.75232L21.9257 2.53992V15.8719L16.625 12.579V5.75232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.1244 1.97772H14.5369C15.1794 1.97772 15.6613 2.45955 15.6613 3.10213V15.2294C15.6613 15.8719 15.1794 16.3538 14.5369 16.3538H1.1244C0.481923 16.3538 0 15.872 0 15.2294V3.10213C0 2.45965 0.481829 1.97772 1.1244 1.97772ZM6.9071 7.59974C6.50555 7.68 6.10397 7.76039 5.7827 7.68C6.42518 9.52716 7.14803 10.6516 8.43309 12.1776C8.59374 11.8563 8.75439 11.6154 8.99529 11.3744L11.9669 14.5066C7.79067 18.3618 0.0804041 4.78862 5.62224 3.18242L6.90729 7.59979L6.9071 7.59974Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3252_16677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9255,
    height: 16.82,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoCall);
export default __webpack_public_path__ + "static/media/icon-video-call.f2010e8a262c6cc88554666cd61a71f3.svg";
export { ForwardRef as ReactComponent };